<template lang="pug">
    div(:class="titleClass" style="flex-grow: 1;")
        | {{ title }}
</template>

<script lang="ts">
import Vue from 'vue';

// Components

export default Vue.extend({
    data() {
        return {

        }
    },
    methods: {

    },
    computed: {
        title() {
            if (!this.validScorecardOrLlmAssessment) {
                return;
            }

            if (this.isScorecard) {
                return this.scorecardOrLlmAssessment?.llm_assessment?.is_flagged ? "Flagged by Pulse" : "Approved by Pulse";
            }

            if (this.isLlmAssessment) {
                return this.scorecardOrLlmAssessment?.is_flagged ? "Flagged by Pulse" : "Approved by Pulse";
            }

            if (this.scorecardOrLlmAssessment?.name?.length > 0) {
                return this.scorecardOrLlmAssessment.name;
            }

            return "Pulse Assessment";
        },
        titleClass() {
            if (this.title === "Approved by Pulse") {
                return "by-pulse-banner approved-by-pulse-banner";
            }
            if (this.title === "Flagged by Pulse") {
                return "by-pulse-banner flagged-by-pulse-banner";
            }
            return "";
        },
        validScorecardOrLlmAssessment() {
            return this.scorecardOrLlmAssessment?.scorecard_id > 0 || this.scorecardOrLlmAssessment?.llm_assessment_id > 0;
        },
        isLlmAssessment() {
            return this.itemType === 'llm_assessment';
        },
        isScorecard() {
            return this.itemType === 'scorecard';
        },
    },
    components: {

    },
    props: {
        scorecardOrLlmAssessment: {
            type: Object,
            required: true,
        },
        itemType: {
            type: String,
            required: true,
            validator(value: string) {
                return ['scorecard', 'llm_assessment'].includes(value);
            },
        }
    },
})
</script>

<style lang="scss" scoped>

</style>